













































































































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import BaseCard from '@/modules/shared/components/shared/base/BaseCard.vue'
import { Prop } from 'vue-property-decorator'
import { BankAccountType } from '@/modules/bank-account/models/bank-account-resource.model'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import { DepositBankAccountStatus } from '@/modules/deposit-bank-account/models/deposit-bank-account-resource.model'
import BaseInput from '@/modules/shared/components/shared/kit/BaseInput.vue'
import {
  DepositBankAccountRequestModel
} from '@/modules/deposit-bank-account/models/deposit-bank-account-request.model'
import BaseSelect from '@/modules/shared/components/shared/kit/BaseSelect.vue'
import Toggle from '@/modules/shared/components/shared/kit/Toggle.vue'
import ShebaInput from '@/modules/shared/components/shared/form/ShebaInput.vue'

@Component({
  components: {
    ShebaInput,
    Toggle,
    BaseSelect,
    BaseInput,
    BaseButton,
    BaseCard
  }
})
export default class AdminDepositBankAccountBaseForm extends Vue {
  @Prop({ required: true }) bankAccountTypesInPersian: { [key in BankAccountType]: string }
  @Prop({ required: true }) depositBankAccountStatusesInPersian: { [key in DepositBankAccountStatus]: string }
  @Prop({ default: () => ({}) }) innerCardProps: object
  @Prop({ default: false }) loading: boolean
  @Prop({ default: false }) disable: boolean
  @Prop({ default: false }) noHeader: boolean
  @Prop({ default: '' }) headerIcon: string
  @Prop({ default: 'q-px-xl' }) submitButtonClasses: string
  @Prop({ default: 'ثبت' }) submitButtonLabel: string
  @Prop({ default: false }) footerSeparator: boolean
  @Prop() headerText: string
  @Prop() submitButtonIcon: string

  protected __loadingState: boolean = false

  protected requestData: DepositBankAccountRequestModel = {
    account_number: null,
    account_owner_name: null,
    account_type: BankAccountType.NATURAL_PERSON,
    card_number: null,
    default: true,
    sheba: null,
    status: DepositBankAccountStatus.ACTIVE,
    title: null
  }

  protected get loadingState() {
    return this.loading || this.__loadingState
  }

  protected get accountTypeOptions() {
    return [
      { value: BankAccountType.NATURAL_PERSON, label: 'غیر رسمی' },
      { value: BankAccountType.LEGAL_PERSON, label: 'رسمی' }
    ]
  }

  protected get accountStatusesOptions() {
    return [
      { value: DepositBankAccountStatus.ACTIVE, label: 'فعال' },
      { value: DepositBankAccountStatus.INACTIVE, label: 'غیر فعال' }
    ]
  }

  protected setValue(key, value) {
    this.$set(this.requestData, key, value)
  }

  protected onSubmit() {
  }
}
